import React from 'react';
import { useId } from 'react-id-generator';
import stringFormat from 'string-format';

interface CheckboxGroupProps {
  className?: string;
  handleChange: (arg: string[]) => void;
  items: {disabled: boolean}[];
  labelFormat: string;
  values: string[];
  valueFormat: string;
}
const CheckboxGroup = ({className, handleChange, items, labelFormat, values, valueFormat}: CheckboxGroupProps) => {
  const [ idPrefix ] = useId();

  return (
    <div className={className}>
      {items.map(item => {
        const optionValue = stringFormat(valueFormat, item);
        const optionLabel = stringFormat(labelFormat, item);

        const name = `${idPrefix}-[${optionValue}]`;
        return (
          <React.Fragment key={optionValue}>
            <input
              type="checkbox"
              name={name}
              value={optionValue}
              id={name}
              checked={values.includes(optionValue) && !item.disabled}
              disabled={item.disabled}
              onChange={e => {
                const newValues = [...values];
                if (e.target.checked) {
                  newValues.push(optionValue);
                } else {
                  newValues.splice(newValues.indexOf(optionValue), 1);
                }
                handleChange(newValues);
              }}/>
            <label htmlFor={name}>{optionLabel}</label>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CheckboxGroup;
